import { createContext } from "@lit/context";

export interface IFilter {
  name: string;
  value: string;
  param: string;
}
export interface IFilterResult {
  facets: string;
  results: string;
  pagination: string;
  total: number;
  pageSize: number;
}

export interface IFilterContext {
  filters?: IFilter[];
  updateFilters: (filter: IFilter, operation: "add" | "remove") => void;
  resetFacets: () => void;
  isLoading: boolean;
  total: number;
  pageSize: number;
  result?: IFilterResult | undefined;
  currentForm?: HTMLFormElement | null;
  abortFetch?: () => void;
  activeElement?: HTMLElement | null;
}

export const filterContext = createContext<IFilterContext>("filter-context");
